/* tslint:disable */
/* eslint-disable */
/**
 * All APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { NamedAreaFilter } from './NamedAreaFilter';
import {
    instanceOfNamedAreaFilter,
    NamedAreaFilterFromJSON,
    NamedAreaFilterFromJSONTyped,
    NamedAreaFilterToJSON,
} from './NamedAreaFilter';
import type { PolygonFilter } from './PolygonFilter';
import {
    instanceOfPolygonFilter,
    PolygonFilterFromJSON,
    PolygonFilterFromJSONTyped,
    PolygonFilterToJSON,
} from './PolygonFilter';
import type { RadiusFilter } from './RadiusFilter';
import {
    instanceOfRadiusFilter,
    RadiusFilterFromJSON,
    RadiusFilterFromJSONTyped,
    RadiusFilterToJSON,
} from './RadiusFilter';

/**
 * @type FindListingsAv8RequestAreaFilter
 * 
 * @export
 */
export type FindListingsAv8RequestAreaFilter = NamedAreaFilter | PolygonFilter | RadiusFilter;

export function FindListingsAv8RequestAreaFilterFromJSON(json: any): FindListingsAv8RequestAreaFilter {
    return FindListingsAv8RequestAreaFilterFromJSONTyped(json, false);
}

export function FindListingsAv8RequestAreaFilterFromJSONTyped(json: any, ignoreDiscriminator: boolean): FindListingsAv8RequestAreaFilter {
    if (json == null) {
        return json;
    }
    if (typeof json !== 'object') {
        return json;
    }
    if (instanceOfNamedAreaFilter(json)) {
        return NamedAreaFilterFromJSONTyped(json, true);
    }
    if (instanceOfPolygonFilter(json)) {
        return PolygonFilterFromJSONTyped(json, true);
    }
    if (instanceOfRadiusFilter(json)) {
        return RadiusFilterFromJSONTyped(json, true);
    }
    return {} as any;
}

export function FindListingsAv8RequestAreaFilterToJSON(json: any): any {
    return FindListingsAv8RequestAreaFilterToJSONTyped(json, false);
}

export function FindListingsAv8RequestAreaFilterToJSONTyped(value?: FindListingsAv8RequestAreaFilter | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }
    if (typeof value !== 'object') {
        return value;
    }
    if (instanceOfNamedAreaFilter(value)) {
        return NamedAreaFilterToJSON(value as NamedAreaFilter);
    }
    if (instanceOfPolygonFilter(value)) {
        return PolygonFilterToJSON(value as PolygonFilter);
    }
    if (instanceOfRadiusFilter(value)) {
        return RadiusFilterToJSON(value as RadiusFilter);
    }
    return {};
}

